module.exports = __webpack_public_path__ + "img/401.48d91682.png";